export const defaultString = "0.1;0;false;0;false;0;0;0;true;true;0.5;";
export const defaultSettings = {
  bet: "0",
  auto: {
    numberOfBets: "0",
    onWinReset: false,
    onWinPercent: "0",
    onLossReset: false,
    onLossPercent: "0",
    stopOnProfit: "0",
    stopOnLoss: "0",
  },
  audio: {
    music: true,
    sound: true,
    volume: "0.5",
  },
};
export const mainProps = ["bet", "auto", "audio"];
export const autoProps = [
  "numberOfBets",
  "onWinReset",
  "onWinPercent",
  "onLossReset",
  "onLossPercent",
  "stopOnProfit",
  "stopOnLoss",
];
export const audioProps = ["music", "sound", "volume"];
